module.exports = "<p>\r\n  Loading word cloud...\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/Alec/Documents/dev/recog/recog/src/app/collection-module/view/word-cloud/word-cloud.component.html
// module id = ../../../../../src/app/collection-module/view/word-cloud/word-cloud.component.html
// module chunks = main